import React from 'react'
import { Link } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Bulletins } from '../../../../common/validations'

import { EmptyState } from 'components/EmptyState/EmptyState'
import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'
import { BulletinListItem } from 'components/BulletinList/components/BulletinListItem/BulletinListItem'

interface BulletinsListProps {
  bulletins: Bulletins
  hasMoreBulletins: boolean
}

export const BulletinsList: React.FC<BulletinsListProps> = ({
  bulletins,
  hasMoreBulletins,
}) => {
  const { t } = useTranslation(['common'])
  const { bulletinBoardPath } = useContractPaths()
  const navigate = useNavigate()

  return (
    <div className="space-y-8">
      {!bulletins.length && <EmptyState title={t('common:noBulletins')} />}
      {bulletins.map((bulletin, indx) => (
        <BulletinListItem
          key={bulletin.uuid}
          bulletin={bulletin}
          lastBulletin={indx === bulletins.length - 1 && !hasMoreBulletins}
        />
      ))}
      {hasMoreBulletins && (
        <div className="flex justify-center mt-8">
          <Link
            to={bulletinBoardPath}
            onPress={() => {
              navigate(bulletinBoardPath)
            }}
            className="underline"
          >
            {t('common:moreBulletins')}
          </Link>
        </div>
      )}
    </div>
  )
}
